import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import PropertyInformationsIcon from '@/svg-icons/PropertyInformations';

const PropertyInformationsSection = ({ data }) => (
  <div className="w-full">
    <div className="font-bold text-[calc(6px+0.4vw)] my-[0.6vw] flex items-center">
      <PropertyInformationsIcon className="text-gray-700 mr-2 w-6 h-6 shrink-0" />
      <FormattedMessage id="propertyInformations" />
    </div>

    <div className="flex flex-wrap text-[#858585] text-[calc(6px+0.4vw)] my-[1vw] pl-[calc(14px+1.8vw)]">
      <div className="w-1/2 mb-[1vw]">
        <div className="font-bold">
          <FormattedMessage id="link" />
        </div>
        <a
          href={data.link}
          target="_blank"
          rel="noreferrer noopener"
          data-cy="order-details-property-link"
          className="truncate block hover:underline"
        >
          {data.link || '----'}
        </a>
      </div>

      <div className="w-1/2 mb-[1vw]" data-cy="order-details-property-highlights">
        <div className="font-bold">
          <FormattedMessage id="highlights" />
        </div>
        <span>{data.highlights || '----'}</span>
      </div>

      {data.otherInformations && (
        <div className="w-full mb-[1vw]" data-cy="order-details-property-other-informations">
          <div className="font-bold">
            <FormattedMessage id="otherInformations" />
          </div>
          <div className="whitespace-pre-wrap">
            {data.otherInformations}
          </div>
        </div>
      )}
    </div>
  </div>
);

PropertyInformationsSection.propTypes = {
  data: PropTypes.object.isRequired,
};

export default PropertyInformationsSection;
